import React, { useEffect } from "react";
import { useDispatch } from "react-redux";

import { makeStyles } from "@material-ui/core/styles";
import styles from "../../../assets/jss/components/tableStyle";
import {
  Typography,
  TableContainer,
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
  Paper,
  Button,
  TextField,
  Icon,
  FormControl,
  Grid,
  Select,
  MenuItem,
  InputLabel,
  FormHelperText,
  IconButton,
  Grow,
  Slide,
  Tooltip,
  Badge,
} from "@material-ui/core";
import CardBody from "../../../common/components/Card/CardBody";
import { DropzoneArea } from "material-ui-dropzone";
import Card from "../../../common/components/Card/Card";
import CardHeader from "../../../common/components/Card/CardHeader";
import DateFnsUtils from "@date-io/date-fns";
import {
  MuiPickersUtilsProvider,
  KeyboardDatePicker,
} from "@material-ui/pickers";
import { ProfessionalEventRepository } from "./ProfessionalEventRepository";
import {
  professionalEventValidator,
  professionalEventPointsValidator,
} from "./ProfessionalEventValidator";
import Upload from "../../../common/components/Upload";
import { LOCALE } from "../../../properties/Locale";
import GradingCommentComponent from "./GradingCommentComponent";
import { Alert, AlertTitle } from "@material-ui/lab";

const useStyles = makeStyles(styles);

export default function ProfessionalEventComponent(props) {
  const classes = useStyles();
  const dispatch = useDispatch();

  const [btnDisabled, setBtnDisabled] = React.useState(false);
  const [professionalEventTypes, setProfessionalEventTypes] = React.useState();
  const [professionalEventRoles, setProfessionalEventRoles] = React.useState();

  const [rerender, triggerRerender] = React.useState(false);
  const [professionalEventData, setProfessionalEventData] = React.useState([]);
  const [professionalEventDataFormErrors, setProfessionalEventDataFormErrors] =
    React.useState({});
  const [showCommentDialog, setShowCommentDialog] = React.useState(false);
  const [commentItem, setCommentItem] = React.useState();
  const [commentIndex, setCommentIndex] = React.useState();

  useEffect(() => {
    triggerRerender(!rerender);
  }, [professionalEventDataFormErrors]);

  useEffect(() => {
    ProfessionalEventRepository.getAllRoles(props.gradingSchemaId).then(
      (res) => {
        setProfessionalEventRoles(res.data);
      }
    );
    ProfessionalEventRepository.getAllTypes(props.gradingSchemaId).then(
      (res) => {
        setProfessionalEventTypes(res.data);
      }
    );
    ProfessionalEventRepository.getProfessionalEventData(
      props.vacancyAppId
    ).then(
      (res) => {
        if (res.data.length > 0) setProfessionalEventData(res.data);
      },
      (err) => {}
    );
  }, []);

  const addRow = () => {
    let data = professionalEventData;
    data.push({
      name: "",
      type: { id: "" },
      role: { id: "" },
      date: new Date(),
      proofs: [],
    });
    setProfessionalEventData(data);
    setProfessionalEventDataFormErrors({});
    triggerRerender(!rerender);
  };

  const deleteRow = (index) => {
    let data = professionalEventData;
    data.splice(index, 1);
    setProfessionalEventData(data);
    setProfessionalEventDataFormErrors({});
    triggerRerender(!rerender);
  };

  const handleChange = (event, index, name) => {
    let data = professionalEventData;
    if (name == "type" || name == "role") {
      data[index][name]["id"] = event.target.value;
    } else {
      data[index][name] = event.target.value;
    }
    setProfessionalEventData(data);
    triggerRerender(!rerender);
  };

  const handleChangeDate = (date, index, name) => {
    let data = professionalEventData;
    data[index][name] = date;
    setProfessionalEventData(data);
    triggerRerender(!rerender);
  };

  const handleClickNext = () => {
    setBtnDisabled(true);
    let data = professionalEventData;
    var validFormData = true;
    for (var i = 0; i < data.length; i++) {
      if (!professionalEventValidator.isValidSync(data[i])) {
        validFormData = false;
        break;
      }
    }
    if (validFormData) {
      saveData("next");
    } else {
      var validationErrors = [];
      (async () => {
        for (var i = 0; i < data.length; i++) {
          validationErrors[i] = {};
          await professionalEventValidator
            .validate(data[i], { abortEarly: false })
            .catch((err) => {
              err.inner.forEach((validationError) => {
                validationErrors[i][validationError.path] = {};
                validationErrors[i][validationError.path].message =
                  validationError.message;
              });
            });
        }
      })();
      setBtnDisabled(false);
      setProfessionalEventDataFormErrors(validationErrors);
    }
  };

  const handleClickPrev = () => {
    setBtnDisabled(true);
    let data = professionalEventData;
    var validFormData = true;
    for (var i = 0; i < data.length; i++) {
      if (!professionalEventValidator.isValidSync(data[i])) {
        validFormData = false;
        break;
      }
    }
    if (validFormData) {
      saveData("prev");
    } else {
      var validationErrors = [];
      (async () => {
        for (var i = 0; i < data.length; i++) {
          validationErrors[i] = {};
          await professionalEventValidator
            .validate(data[i], { abortEarly: false })
            .catch((err) => {
              err.inner.forEach((validationError) => {
                validationErrors[i][validationError.path] = {};
                validationErrors[i][validationError.path].message =
                  validationError.message;
              });
            });
        }
      })();
      setBtnDisabled(false);
      setProfessionalEventDataFormErrors(validationErrors);
    }
  };

  const saveData = (step) => {
    ProfessionalEventRepository.saveProfessionalEventData(
      props.vacancyAppId,
      professionalEventData
    ).then(
      (res) => {
        if (step === "next") {
          props.handleNextStep();
        } else {
          props.handlePreviousStep();
        }
      },
      (err) => {
        setBtnDisabled(false);
      }
    );
  };

  const addAttachments = (index, attachments) => {
    let data = professionalEventData;
    data[index].proofs = attachments;
    setProfessionalEventData(data);
  };

  const changePoints = (item) => {
    ProfessionalEventRepository.updatePoints(item.id, item.points).then(
      (res) => {
        ProfessionalEventRepository.getProfessionalEventData(
          props.vacancyAppId
        ).then(
          (res) => {
            if (res.data.length > 0) {
              setProfessionalEventData(res.data);
              setProfessionalEventDataFormErrors({});
              triggerRerender(!rerender);
            }
          },
          (err) => {}
        );
      }
    );
  };

  const unlockPoints = (item) => {
    ProfessionalEventRepository.unlockPoints(item.id).then((res) => {
      ProfessionalEventRepository.getProfessionalEventData(
        props.vacancyAppId
      ).then(
        (res) => {
          if (res.data.length > 0) {
            setProfessionalEventData(res.data);
            triggerRerender(!rerender);
          }
        },
        (err) => {}
      );
    });
  };

  const evaluationNextStep = (data) => {
    var validFormData = true;
    for (var i = 0; i < data.length; i++) {
      if (!professionalEventPointsValidator.isValidSync(data[i])) {
        validFormData = false;
        break;
      }
    }
    if (validFormData) {
      props.handleEvaluationNextStep(data, "professional_event");
    } else {
      var validationErrors = [];
      (async () => {
        for (var i = 0; i < data.length; i++) {
          validationErrors[i] = {};
          await professionalEventPointsValidator
            .validate(data[i], { abortEarly: false })
            .catch((err) => {
              err.inner.forEach((validationError) => {
                validationErrors[i][validationError.path] = {};
                validationErrors[i][validationError.path].message =
                  validationError.message;
              });
            });
        }
      })();
      setBtnDisabled(false);
      setProfessionalEventDataFormErrors(validationErrors);
    }
  };

  const openCommentDialog = (item, index) => {
    setCommentItem(item);
    setCommentIndex(index);
    setShowCommentDialog(true);
  };

  const closeCommentDialog = (item, index) => {
    if (item != undefined) {
      ProfessionalEventRepository.setComment(item.id, item.comment).then(
        (res) => {
          let tmp = professionalEventData;
          tmp[index] = item;
          setProfessionalEventData(tmp);
          triggerRerender(!rerender);
          setShowCommentDialog(false);
        }
      );
    } else {
      setShowCommentDialog(false);
    }
  };

  return (
    <div>
      {!props.disabled && (
        <Alert
          style={{ marginBottom: "45px", marginTop: "10px" }}
          fullwidth="true"
          severity="info"
        >
          <AlertTitle>{LOCALE.professional_event_info_title}</AlertTitle>
          {LOCALE.professional_event_info_description}
        </Alert>
      )}
      <Card>
        <CardHeader
          color="theme"
          style={{ padding: "8px", paddingLeft: "15px" }}
        >
          <Grid container>
            <Grid item xs={8}>
              {" "}
              <Typography>
                {LOCALE.list_of_proofs_for_professional_development},{" "}
                {LOCALE.domain} {LOCALE.professional_events}
              </Typography>
            </Grid>
            <Grid item xs={2}></Grid>
            <Grid item xs={2}>
              {" "}
              {!props.disabled && (
                <Button
                  color="default"
                  variant="contained"
                  className={
                    professionalEventData.length == 0 ? "bounceButton" : ""
                  }
                  startIcon={<Icon>add_circle_outline</Icon>}
                  size="small"
                  aria-label="create"
                  style={{ float: "right" }}
                  onClick={addRow}
                >
                  {LOCALE.add_professional_event}
                </Button>
              )}
            </Grid>
          </Grid>
        </CardHeader>
        <CardBody>
          <Table aria-label="groups table" className={classes.table}>
            <TableHead>
              <TableRow className={classes.tableHeadRow}>
                <TableCell
                  className={classes.tableCell + " " + classes.tableHeadCell}
                >
                  {LOCALE.num}
                </TableCell>
                <TableCell
                  className={classes.tableCell + " " + classes.tableHeadCell}
                >
                  {LOCALE.professional_event_name}
                </TableCell>
                <TableCell
                  className={classes.tableCell + " " + classes.tableHeadCell}
                >
                  {LOCALE.professional_event_type}
                </TableCell>
                <TableCell
                  className={classes.tableCell + " " + classes.tableHeadCell}
                >
                  {LOCALE.professional_event_role}
                </TableCell>
                <TableCell
                  className={classes.tableCell + " " + classes.tableHeadCell}
                >
                  {LOCALE.date}
                </TableCell>
                <TableCell
                  className={classes.tableCell + " " + classes.tableHeadCell}
                >
                  {LOCALE.place}
                </TableCell>

                <TableCell
                  className={classes.tableCell + " " + classes.tableHeadCell}
                >
                  {LOCALE.proof}
                </TableCell>
                <TableCell
                  className={classes.tableCell + " " + classes.tableHeadCell}
                >
                  {LOCALE.actions}
                </TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {professionalEventData.length > 0 ? (
                professionalEventData.map((item, index) => (
                  <TableRow
                    key={index}
                    className={classes.tableBodyRow}
                    style={index % 2 ? { background: "#f0f0f0" } : {}}
                  >
                    <TableCell className={classes.tableCell}>
                      {index + 1}
                    </TableCell>
                    <TableCell className={classes.tableCell}>
                      <Tooltip
                        title={item.name}
                        style={{ color: "white" }}
                        disableHoverListener={!props.evaluation}
                      >
                        <TextField
                          disabled={props.disabled}
                          value={item.name}
                          variant="outlined"
                          label={LOCALE.professional_event_name}
                          error={professionalEventDataFormErrors[index]?.name}
                          helperText={
                            professionalEventDataFormErrors[index]?.name
                              ?.message
                          }
                          size="small"
                          onChange={(e) => handleChange(e, index, "name")}
                        />
                      </Tooltip>
                    </TableCell>
                    <TableCell className={classes.tableCell}>
                      <Tooltip
                        title={item.type.name}
                        style={{ color: "white" }}
                        disableHoverListener={!props.evaluation}
                      >
                        <FormControl
                          disabled={props.disabled}
                          className={classes.formControl}
                          style={{ width: "250px" }}
                          variant="outlined"
                          error={
                            professionalEventDataFormErrors[index] &&
                            professionalEventDataFormErrors[index]["type.id"]
                          }
                          size="small"
                        >
                          <InputLabel id="demo-simple-select-label">
                            {LOCALE.professional_event_type}
                          </InputLabel>
                          <Select
                            labelId="demo-simple-select-label"
                            id="demo-simple-select"
                            label={LOCALE.professional_event_name}
                            value={item.type.id}
                            onChange={(e) => handleChange(e, index, "type")}
                          >
                            {professionalEventTypes?.map((item, index) => (
                              <MenuItem key={index} value={item.id}>
                                {item.name}
                              </MenuItem>
                            ))}
                          </Select>
                          <FormHelperText id="municipality-helper-text">
                            {professionalEventDataFormErrors[index] &&
                              professionalEventDataFormErrors[index]["type.id"]
                                ?.message}
                          </FormHelperText>
                        </FormControl>
                      </Tooltip>
                    </TableCell>
                    <TableCell className={classes.tableCell}>
                      <Tooltip
                        title={item.role.name}
                        style={{ color: "white" }}
                        disableHoverListener={!props.evaluation}
                      >
                        <FormControl
                          disabled={props.disabled}
                          className={classes.formControl}
                          style={{ width: "250px" }}
                          variant="outlined"
                          error={
                            professionalEventDataFormErrors[index] &&
                            professionalEventDataFormErrors[index]["role.id"]
                          }
                          size="small"
                        >
                          <InputLabel id="demo-simple-select-label">
                            {LOCALE.professional_event_role}
                          </InputLabel>
                          <Select
                            labelId="demo-simple-select-label"
                            id="demo-simple-select"
                            label={LOCALE.professional_event_role}
                            value={item.role.id}
                            onChange={(e) => handleChange(e, index, "role")}
                          >
                            {professionalEventRoles?.map((item, index) => (
                              <MenuItem key={index} value={item.id}>
                                {item.name}
                              </MenuItem>
                            ))}
                          </Select>
                          <FormHelperText id="municipality-helper-text">
                            {professionalEventDataFormErrors[index] &&
                              professionalEventDataFormErrors[index]["role.id"]
                                ?.message}
                          </FormHelperText>
                        </FormControl>
                      </Tooltip>
                    </TableCell>
                    <TableCell className={classes.tableCell}>
                      <FormControl
                        disabled={props.disabled}
                        fullWidth
                        style={{ marginTop: -15 }}
                        error={
                          professionalEventDataFormErrors[index] &&
                          professionalEventDataFormErrors[index]["date"]
                        }
                      >
                        <MuiPickersUtilsProvider utils={DateFnsUtils}>
                          <KeyboardDatePicker
                            disabled={props.disabled}
                            disableToolbar
                            variant="outlined"
                            format="MM/dd/yyyy"
                            margin="normal"
                            id="date-from"
                            label="Датум"
                            value={item.date}
                            onChange={(date) =>
                              handleChangeDate(date, index, "date")
                            }
                          />
                        </MuiPickersUtilsProvider>
                        <FormHelperText id="municipality-helper-text">
                          {professionalEventDataFormErrors[index] &&
                            professionalEventDataFormErrors[index]["date"]
                              ?.message}
                        </FormHelperText>
                      </FormControl>
                    </TableCell>
                    <TableCell className={classes.tableCell}>
                      <Tooltip
                        title={item.place}
                        style={{ color: "white" }}
                        disableHoverListener={!props.evaluation}
                      >
                        <TextField
                          disabled={props.disabled}
                          value={item.place}
                          variant="outlined"
                          label={LOCALE.place}
                          error={professionalEventDataFormErrors[index]?.place}
                          helperText={
                            professionalEventDataFormErrors[index]?.place
                              ?.message
                          }
                          size="small"
                          onChange={(e) => handleChange(e, index, "place")}
                        />
                      </Tooltip>
                    </TableCell>
                    <TableCell className={classes.tableCell}>
                      <FormControl
                        disabled={props.disabled}
                        className={classes.formControl}
                        variant="outlined"
                        error={
                          professionalEventDataFormErrors[index] &&
                          professionalEventDataFormErrors[index]["proofs"]
                        }
                        size="small"
                      >
                        <Upload
                          vacancyAppDomain={"PROFESSIONAL_EVENT"}
                          vacancyAppId={props.vacancyAppId}
                          attachments={item.proofs}
                          onComponentClose={addAttachments}
                          rowIndex={index}
                          disabled={props.disabled}
                        />
                        <FormHelperText id="municipality-helper-text">
                          {professionalEventDataFormErrors[index] &&
                            professionalEventDataFormErrors[index]["proofs"]
                              ?.message}
                        </FormHelperText>{" "}
                      </FormControl>
                    </TableCell>
                    {props.showPoints && (
                      <React.Fragment>
                        <TableCell className={classes.tableCell}>
                          <TextField
                            disabled={true}
                            value={item.points}
                            variant="outlined"
                            label={LOCALE.points}
                            style={{ maxWidth: "80px" }}
                            size="small"
                          />
                        </TableCell>
                      </React.Fragment>
                    )}
                    {!props.disabled && (
                      <TableCell className={classes.tableCell}>
                        <IconButton
                          disabled={props.disabled}
                          color="secondary"
                          size="small"
                          aria-label="delete"
                          onClick={() => deleteRow(index)}
                        >
                          <Icon>delete</Icon>
                        </IconButton>
                        {/* {props.status === "ADDITIONAL_DATA_REQUIRED" && (
                          <Tooltip
                            title={LOCALE.comment}
                            aria-label={LOCALE.comment}
                          >
                            <Badge
                              badgeContent={item.comment ? 1 : 0}
                              color="secondary"
                            >
                              <IconButton
                                color="primary"
                                size="small"
                                style={{ top: "6px" }}
                                onClick={() => openCommentDialog(item, index)}
                              >
                                <Icon>message</Icon>
                              </IconButton>
                            </Badge>
                          </Tooltip>
                        )} */}
                      </TableCell>
                    )}
                    {props.evaluation && (
                      <TableCell className={classes.tableCell} width={150}>
                        <FormControl
                          style={{ display: "inline" }}
                          error={
                            professionalEventDataFormErrors[index] &&
                            professionalEventDataFormErrors[index][
                              "pointsChecked"
                            ]
                          }
                        >
                          <TextField
                            disabled={item.pointsChecked}
                            value={item.points}
                            variant="outlined"
                            label="Поени"
                            style={{ maxWidth: "80px" }}
                            size="small"
                            onChange={(e) => handleChange(e, index, "points")}
                          />
                          {!item.pointsChecked && (
                            <Tooltip
                              title={LOCALE.confirm_points}
                              aria-label={LOCALE.confirm_points}
                            >
                              <IconButton
                                style={{ color: "green", top: "6px" }}
                                size="small"
                                onClick={() => changePoints(item)}
                              >
                                <Icon>check</Icon>
                              </IconButton>
                            </Tooltip>
                          )}
                          {item.pointsChecked && (
                            <Tooltip
                              title={LOCALE.change_points}
                              aria-label={LOCALE.change_points}
                            >
                              <IconButton
                                style={{ color: "red", top: "6px" }}
                                size="small"
                                onClick={() => unlockPoints(item)}
                              >
                                <Icon>clear</Icon>
                              </IconButton>
                            </Tooltip>
                          )}
                          <Tooltip
                            title={LOCALE.comment}
                            aria-label={LOCALE.comment}
                          >
                            <Badge
                              badgeContent={item.comment ? 1 : 0}
                              color="secondary"
                            >
                              <IconButton
                                color="primary"
                                size="small"
                                style={{ top: "6px" }}
                                onClick={() => openCommentDialog(item, index)}
                              >
                                <Icon>message</Icon>
                              </IconButton>
                            </Badge>
                          </Tooltip>
                          <FormHelperText id="municipality-helper-text">
                            {professionalEventDataFormErrors[index] &&
                              professionalEventDataFormErrors[index][
                                "pointsChecked"
                              ]?.message}
                          </FormHelperText>{" "}
                        </FormControl>
                      </TableCell>
                    )}
                  </TableRow>
                ))
              ) : (
                <TableRow>
                  <TableCell colSpan={8}>
                    <Icon style={{ verticalAlign: "bottom", color: "orange" }}>
                      warning
                    </Icon>{" "}
                    {LOCALE.no_professional_event_added}
                  </TableCell>
                </TableRow>
              )}
            </TableBody>
          </Table>
        </CardBody>
      </Card>
      {!props.disabled && (
        <div>
          <Button
            color="secondary"
            variant="contained"
            disabled={btnDisabled}
            style={{ marginRight: "5px", float: "right" }}
            size="small"
            onClick={() => handleClickNext()}
          >
            {LOCALE.next}
          </Button>
          <Button
            style={{ marginRight: "5px", float: "right" }}
            color="secondary"
            variant="outlined"
            disabled={btnDisabled}
            size="small"
            onClick={() => handleClickPrev()}
          >
            {LOCALE.previous}
          </Button>
        </div>
      )}
      {props.evaluation && (
        <div>
          <Button
            color="primary"
            variant="contained"
            style={{ marginRight: "5px", float: "right" }}
            size="small"
            disabled={btnDisabled}
            onClick={() => evaluationNextStep(professionalEventData)}
          >
            {LOCALE.next}
          </Button>
        </div>
      )}
      {showCommentDialog && (
        <GradingCommentComponent
          item={commentItem}
          preview={props.status == "ADDITIONAL_DATA_REQUIRED" ? true : false}
          index={commentIndex}
          handleClose={(item, index) => closeCommentDialog(item, index)}
        />
      )}
    </div>
    // </Slide>
  );
}
